
import { NoticeProps} from "@/scripts/datatypes"
import {GroupData, PostStatus} from '../../common-datatypes'
import {doc,getDoc} from 'firebase/firestore'
import { Component,Mixins } from "vue-property-decorator";
import { ValidationObserver,ValidationProvider } from 'vee-validate'
import Common from '@/mixins/common'
import TemplateMembers from '@/components/TemplateMembers.vue'
import ModalSelectUser from '@/components/ModalSelectUser.vue';
import { ValidationFlags } from "vee-validate/dist/types/types";

@Component({
  components: {
    ModalSelectUser,
    TemplateMembers
  }
})

export default class EditGroup extends Mixins(Common) {
  notice = {} as NoticeProps
  disabledEditGroup = true
  defaultGroupData: GroupData = {
    hostUserIds: [],
    guestUserIds: [],
    name: '',
    description: '',
    memberUserIds: [],
    disabled: false,
    deleted: false,
    memberMeta: {},
    postStatus: 'draft'
  }
  tIsShow = false
  sIsShow = false
  theGroupName = ''
  theGroup = {...this.defaultGroupData}
  initGroupData = {...this.defaultGroupData}
  isLoading = false

  get existGroup(){
    return !! this.theGroup.creationTime
  }

  get theGroupId(){
    return this.$route.params.groupId || ''
  }

  $refs!: {
    hosts: InstanceType<typeof ValidationProvider>;
    guests: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  postStatuses(){
    if(this.$te('event.postStatus')){
      return this.$t('event.postStatus') as unknown as PostStatus
    }
    return undefined
  }

  get memberUserIds(){
    return [...this.theGroup.hostUserIds,...this.theGroup.guestUserIds]
  }

  get theGroupDoc(){
    return doc(this.$getGroupsColRef(),this.theGroupId)
  }

  async editGroup(){
		try{
			this.notice = {
				isShow: false,
			}
		
      if(await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        const data: GroupData = {
          ...this.theGroup,
          memberUserIds: this.memberUserIds
        }

        await this.$updateDoc(this.theGroupDoc,data)
        
        this.notice = {
          message: this.$t('editGroup.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
        
        this.theGroupName = this.theGroup.name || ''
        this.$nextTick(() => {
          this.$refs.validationObserver.reset()
        })
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('editGroup.error') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      try{
        const theGroupDocData = await getDoc(this.theGroupDoc)
        if(theGroupDocData.exists()){
          const data = theGroupDocData.data() as GroupData
          this.theGroup = {...this.theGroup,...data}
          this.initGroupData = {...this.theGroup}
        }

        if(! this.existGroup){
          throw Error()
        }
      }catch(error){
        this.notice = {
          message: this.$t('editGroup.noGroupFound') as string,
          isShow: true,
          duration: 0,
          type: {'is-danger': true}
        }
      }
      this.theGroupName = this.theGroup.name || ''

    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  updated(){
    console.log('updated')
    if(! this.unwatch && this.$refs.validationObserver){
      this.unwatch = this.$watch('$refs.validationObserver.flags',(flags: ValidationFlags) => {
        this.disabledEditGroup = ! flags.changed
      })
    }
  }

  unwatch?: () => void


  destroyed() {
    console.trace('destroyed');
  }

}
